export enum badgeType {
    success,
    error,
    warning,
    info
}

export enum contactUsType {
    CHECK,
    REFOLLOW,
    DONE
}

export enum priceType {
    GRADE_ONE = 1,
    GRADE_TWO = 2,
    GRADE_THREE = 3
}

export enum GenderType {
    FEMALE = 0,
    MALE = 1,
}

export enum VideoLinkType {
    LINK = 0,
    KAVIMO = 1,
}

export enum RouterStateSectionType {
    USER,
    PURCHASE,
    COMMENT,
    TICKET,
    SHOP,
    PURCHASE_VIEW,
    PURCHASE_STATUS_VIEW,
}

export enum IncomeType {
    LOW_INCOME,
    MEDIUM_INCOME,
    HIGH_INCOME,
    MAX_HIGH_INCOME
}

export enum EducationType {
    NONE,
    DIPLOMA,
    BACHELOR,
    MASTER,
    PHD
}

export enum EventFileType {
    NONE,
    AUDIO,
    VIDEO
}

export enum BlogFileType {
    NONE,
    AUDIO,
    VIDEO
}

export enum TicketSectionType {
    SUPPORT = 1,
    TECHNICAL = 2,
    FINANCIAL = 3,
    EDUCATION = 4
}

export enum TicketStatusType {
    CHECK = 1,
    QUESTION = 2,
    ANSWER = 3,
    CLOSE = 4
}

export enum UserType {
    USER = 1,
    ADMIN = 2,
}

export enum ProductType {
    VIDEO = 1,
    PACKAGE = 2
}

export enum CouponsValueType {
    PERCENT,
    PRICE
}

export enum CouponLimitType {
    ALL_BASKET,
    SPECIAL_PRODUCT,
    BEFORE_PRODUCT,
    FIRST_PRODUCT,
}

export enum TypeVideoProduct {
    COURSE,
    PRODUCT,
    WEBINAR,
    FREE = 3
}

export enum StatusVideoProduct {
    DONE,
    REGISTERING,
    PERFORMING,
    RECORDED,
}

export enum ClassStatusVideoProduct {
    DONE = 0,
    PERFORMING = 2,
}

export enum TeacherSocialNetworkType {
    EMAIL = 1,
    INSTAGRAM = 2,
    TELEGRAM = 3,
    WHATSAPP = 4,
    WEBSITE = 5
}

export enum TeacherAttachmentType {
    IMAGE = 1,
    FILE = 2
}

export enum FileType {
    VIDEO = 1,
    AUDIO = 2,
    FILE = 3
}

export enum PaidStatus {
    FAILED,
    DONE,
}

export enum MethodPayment {
    ONLINE = 1,
    WALLET = 2
}

export enum TransactionWalletType {
    DEPOSIT = 1,
    WITHDRAW = 2
}

export enum VideoProductLikeType {
    DISLIKE,
    LIKE,
}

export enum BlogCategoryType{
    NEWS = 'news',
    ARTICLES = 'articles',
    WEEKLY_REPORTS = 'weekly-reports'
}
